/** A referential list of resource types: no tenant, no parameter. */
class FetchAuditResourceTypes {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAuditResourceTypes;
